const generateBaseId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID().replace(/-/g, '').slice(0, 12);
  }
  return Math.random().toString(36).slice(2, 11);
};

export const createId = (prefix?: string) => {
  const base = generateBaseId();
  return prefix ? `${prefix}-${base}` : base;
};
